import React from 'react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { BodyText, Link, Alert } from '@paypalcorp/pp-react'

function FullAuthNeeded() {
  const { webLLSLogoutUrl } = useApplicationContext()

  return (
    <div>
      <BodyText size="sm">
        <Alert type="info">
          <Link
            href={webLLSLogoutUrl}
            data-dxa="REST-app-management,login-with-password"
          >
            <Message id="full-auth-needed.loginPasswordLink" />
          </Link>{' '}
          <Message id="full-auth-needed.loginPasswordText" />
        </Alert>
      </BodyText>
    </div>
  )
}

export default injectWorldReady(FullAuthNeeded)
